module.exports = __webpack_public_path__ + "img/marshmellows-at-vampire-camp.4532c214.jpg";